module.exports = __webpack_public_path__ + "static/media/harmonhall.8a6b597b.svg";